import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';

/* global customElements */
class UnitMatchGrid extends BaseComponent {
	
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}
	
	constructor() {
		super();
						
		this.admin = false;	
		
		var unitMatchGrid = this;
		setTimeout(function(){
			unitMatchGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var unitMatchGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['UNIT_MATCHING_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['UNIT_MATCHING_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'test',
					'class': 'spacer-toolbar-item',		
					theme: 'contrast',
					disabled: true,	
					permissions: ['UNIT_MATCHING_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Test')						
					],
					listeners: {
						click: function() {
							actionTest(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'upload',						
							disabled: true,
							'class': 'spacer-toolbar-item',					
							permissions: ['UNIT_MATCHING_MANAGEMENT:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', 'Import')						
							],
							listeners: {
								click: function() {
									actionUpload(grid.selectedItems[0]);
								}
							}							
						},
						{
							tag: 'dl-action-button',						
							theme: 'error primary',
							itemid: 'delete',
							disabled: true,
							'class': 'spacer-toolbar-item',
							style: 'float: right;',
							permissions: ['UNIT_MATCHING_MANAGEMENT:DELETE'],
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}
			]
		});		
			
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [	
				{						
					path: 'unitMatchId',
					header: 'Unit Match Id',
					width: '7em'
				},
				{						
					path: 'name',
					header: 'Match Set Name',
					width: '7em'
				},	
				{						
					path: 'rules',
					header: 'Rules',
					width: '7em',
					renderer: function(root, column, rowData) {
						root.innerHTML = 'Rules Defined: ' + rowData.item.rules.length;
					}
				},
				{						
					path: 'activeStatus',
					header: 'Active Status',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},								
				{						
					path: 'updateUser',
					header: 'Update User',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;						
						ElementUtil.query(toolbar, 'upload').disabled = false;
						ElementUtil.query(toolbar, 'test').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;						
						ElementUtil.query(toolbar, 'upload').disabled = true;
						ElementUtil.query(toolbar, 'test').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}
				}
			}
		});	
		
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				if (grid.selectedItems && grid.selectedItems.length > 0) {
					actionExport(grid.selectedItems[0]);
				} else {
					window.DL.MessageUtil.showToastError('A matching set must be selected');
				}
			}
		});
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		unitMatchGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			var loadMask = grid.showLoading();
			
			UnitService.getUnitMatchingService().getUnitMatchingSets().then(function(data){
				loadMask.remove();
				grid.activeItem = null;
				grid.items = data;	
			});			
		};
		actionRefresh();
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var rules = [];
						var ruleGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true				
							},			
							children: [	
								{						
									path: 'referenceTypeDescription',
									header: 'Reference Type',					
									width: '9em'
								},
								{
									path: 'referenceNo',
									header: 'Reference No',
									width: '9em'
								},
								{
									path: 'matchOperationDescription',
									header: 'Match Operation',
									width: '9em'
								},
								{
									path: 'matchValue',
									header: 'Match Value',
									width: '9em'
								}							
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									ruleGrid.selectedItems = item ? [item] : [];
									if (ruleGrid.selectedItems.length > 0) {											
										ElementUtil.query(formPanel, 'editRule').disabled = false;										
										ElementUtil.query(formPanel, 'removeRule').disabled = false;										
									} else {	
										ElementUtil.query(formPanel, 'editRule').disabled = true;										
										ElementUtil.query(formPanel, 'removeRule').disabled = true;
									}	
								}
							}
						});
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',										
											name: 'name',
											label: 'Name',
											colspan: 2,
											required: true,
											maxLength: 120											
										},
										{
											tag: 'dl-section-title',
											title: 'Rules',
											colspan: 2,
											style: 'margin-top: 20px;'											
										},
										{
											tag: 'div',
											style: 'height: 350px;',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [														
														{
															tag: 'dl-toolbar',
															slot: 'toolbar',
															theme: 'spacing',
															children: [																				
																{
																	tag: 'vaadin-button',																	
																	theme: 'primary',
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:plus', ' Add')
																	],
																	listeners: {
																		click: function() {							
																			actionAddEditRule();
																		}
																	}					
																},	
																{
																	tag: 'vaadin-button',
																	itemid: 'editRule',																	
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:edit', ' Edit')
																	],
																	listeners: {
																		click: function() {							
																			actionAddEditRule(ruleGrid.selectedItems[0]);
																		}
																	}					
																},
																{
																	tag: 'vaadin-button',
																	itemid: 'removeRule',
																	theme: 'error primary',																						
																	'class': 'spacer-toolbar-item',
																	style: 'float: right;',					
																	children:[
																		ElementUtil.makeIcon('vaadin:close', ' Remove')
																	],
																	listeners: {
																		click: function() {
																			actionRemoveRule(ruleGrid.selectedItems[0]);
																		}
																	}
																}			
															]
														},
														ruleGrid													
													]
												}
											]
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
															//allow zero rules so they can import them later
															
															formPanel.submitForm({
																preSubmit: function (data) {
																	//add rules
																	data.rules = rules;
																	return data;
																},
																actualCall: function (data) {
																	if (record) {
																		data.unitMatchId = record.unitMatchId;
																	}
																	return UnitService.getUnitMatchingService().saveUnitMatchingSet(data, (record ? true : false));
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Unit Matching Rule Set', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						var actionRefreshRules = function() {														
							ruleGrid.activeItem = null;
							ruleGrid.items = rules.slice(0);	
						};
						
						if (record) {	
							formPanel.load(record);
							
							//load rules
							rules = [];							
							record.ruleViews.forEach(function(rule){										
								rules.push(Object.assign({}, rule));
							});
							
							actionRefreshRules();
						}
						
						var actionRemoveRule = function(rule) {
							var newItems = [];
							rules.forEach(function(item){
								if (item.referenceType !== rule.referenceType && 
									item.referenceId !== rule.referenceId) {
									newItems.push(item);
								}
							});	
							rules = newItems;
							actionRefreshRules();
						};
						
						var actionAddEditRule = function(rule) {
							
							var addEditRuleWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: rule ? 'Edit' : 'Add',
								icon: 'vaadin:edit',
								width: 600,
								height: 400,
								listeners: {
									ready: function () {
										addEditRuleWin.show();
										
										var currentRefType = 'TRACTOR';
										
										var loadReferenceLookup = function(refType, lookupValue) {
											
											var paging = {
												max: 100
											};
											if (lookupValue) {
												paging.filterField = 'description';
												paging.filterValue = lookupValue;
											}
											
											UnitService.getUnitLookupService().getUnits(refType, paging).then(function (units) {
												ElementUtil.query(ruleFormPanel, 'referenceIdCB').items = units.data;
											});											
											 
										};
										
										var ruleFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [
														{
															tag: 'vaadin-combo-box',
															itemid: 'referenceTypeCB',
															name: 'referenceType',															
															label: 'Reference Type',
															'item-value-path': 'code',
															'item-label-path': 'description',															
															value: 'TRACTOR',
															postinit: function (combo) {
																Service.getLookupService().getLookupValues('ReferenceType').then(function (data) {
																	
																	var unitRefs = [];
																	data.forEach(function(item){
																		if (item.unitReference) {
																			unitRefs.push(item);
																		}
																	});
																	
																	combo.items = unitRefs;			
																	combo.required = true;
																});
															},
															listeners: {
																change: function(e) {
																	var typeCB = e.target;
																	
																	currentRefType = typeCB.value;
																	
																	//clear the reference no
																	ElementUtil.query(ruleFormPanel, 'referenceIdCB').value = '';
																	
																	//load on type ahead
																	loadReferenceLookup(currentRefType);
																}
															},
															placeHolder: 'Select'
														},
														{
															tag: 'vaadin-combo-box',															
															itemid: 'referenceIdCB',
															name: 'referenceId',															
															label: 'Reference No',
															'item-value-path': 'code',
															'item-label-path': 'description',
															required: true,
															postinit: function (combo) {
																loadReferenceLookup(currentRefType);
															},
															listeners: {
																input: {
																	fn: function(e) {
																		loadReferenceLookup(currentRefType, e.target.value);	
																	},
																	buffer: 500
																}
															},	
															placeHolder: 'Select'
														},	
														{
															tag: 'vaadin-combo-box',															
															itemid: 'matchOperationCB',
															name: 'matchOperation',															
															label: 'Match Operator',
															'item-value-path': 'code',
															'item-label-path': 'description',
															value: 'CONTAINS',															
															postinit: function (combo) {
																Service.getLookupService().getLookupValues('UnitMatchingOperator').then(function(data) {																	
																	combo.items = data;
																	combo.required = false;
																});
															},															
															placeHolder: 'Select'
														},
														{
															tag: 'div',
															trustedInnerHTML: true,
															innerHTML: '<dl-regex-tester></dl-regex-tester>'
														},
														{
															tag: 'vaadin-text-field',										
															name: 'matchValue',
															label: 'Match Value',															
															required: true,
															maxLength: 255											
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function() {															

																			//get data
																			var data = ruleFormPanel.getData();
																			data.referenceNo = ElementUtil.query(ruleFormPanel, 'referenceIdCB').selectedItem.description;
																			data.matchOperationDescription = ElementUtil.query(ruleFormPanel, 'matchOperationCB').selectedItem.description;
																			data.referenceTypeDescription = ElementUtil.query(ruleFormPanel, 'referenceTypeCB').selectedItem.description;
																			
																			//add record
																			if (!rule) {
																				rules.push(data);																			
																			} else {
																				rule.referenceId = data.referenceId;
																				rule.referenceType = data.referenceType;
																				rule.referenceNo = data.referenceNo;
																				rule.matchOperation = data.matchOperation;
																				rule.matchValue = data.matchValue;
																				rule.referenceTypeDescription = data.referenceTypeDescription;
																				rule.matchOperationDescription = data.matchOperationDescription;
																			}
																			
																			//refresh rules
																			actionRefreshRules();
																			addEditRuleWin.close();
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			addEditRuleWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});			

										addEditRuleWin.addToContentElement(ruleFormPanel);
										
										
										if (rule) {
											ruleFormPanel.load(rule);											
										}
										
									}
								}
							});
							
						};
						
					}
				}
			});			
		};
		
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: '<b>Are you sure you want to delete "' + record.name + '"?</b> <br><i class="fas fa-exclamation-triangle warning-icon"></i>This config will be removed from associated Integrations.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							UnitService.getUnitMatchingService().deleteUnitMatchingSet(record.unitMatchId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed '+ record.name, {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};	
		
		var actionUpload = function(record) {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Import Rules for Selected Set',
				icon: 'vaadin:upload',
				width: 450,
				height: 220,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var uploadHandler = function() {
							
							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');
							
							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('A matching rules import file is required.');
							} else {
								uploadField.uploadFiles();
							}
							
						};
						
						var uploadFormPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [
									{
										tag: 'vaadin-upload',												
										itemid: 'uploadField',
										'no-auto':  true,
										'max-files': 1,
										required: true,
										target: '/api/resource/unit-matching/' + record.unitMatchId + '/import',
										headers: ImportUtil.getUploadHeader(),
										listeners: {
											'upload-request': function(event) {
												//var data = uploadFormPanel.getData();													
												
											},
											'upload-success': function(event) {
												var responseData = JSON.parse(event.detail.xhr.responseText);
												if (responseData.uploadFile) {
													//error 
													window.DL.MessageUtil.showOkMessage(
														responseData.uploadFile + '<br>' +
														responseData.uploadFileType ? responseData.uploadFileType : ''
													);
												} else {
													actionRefresh();
													uploadWin.close();
												}
											}
										}
									},
									{
										tag: 'vaadin-form-layout',										
										children: [											
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:upload', ' Upload')
														],
														listeners: {
															click: function() {
																if (uploadFormPanel.isValid()) {																	
																	uploadHandler();
																}
															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function() {																
																uploadWin.close();
															}
														}
													}
												]
											}
										]
									}
								]
						});
						uploadWin.addToContentElement(uploadFormPanel);
						
					}
				}
				
				
			});					
			
		};
		
		var actionExport = function(record) {
			UnitService.getUnitMatchingService().exportUnitMatchingSet(record.unitMatchId);	
		};
		
		var actionTest = function(record) {
			var testWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Test',
				icon: 'vaadin:input',
				width: .75,
				height: .75,
				listeners: {
					ready: function () {
						testWin.show();
						
						var messagePanel = ElementUtil.create({
							tag: 'div',
							'class': 'regex-tester-message'
						});
						
						//toolbar with form
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							slot: 'toolbar',
							children: [
								messagePanel,
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{
											tag: 'vaadin-text-field',										
											name: 'valueToCheck',
											label: 'Value',																						
											maxLength: 255											
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Reference Type',
											name: 'referenceType',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											value: 'TRACTOR',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('ReferenceType').then(function (data) {
													combo.items = data;
													combo.required = true;													
												});
											}
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:check', ' Test')
													],
													listeners: {
														click: function() {															
															
															var data = formPanel.getData();			
															
															var loadMask = testLayout.showLoading('Checking...');
															UnitService.getUnitMatchingService().checkMatchSet(record.unitMatchId, data).then(function(results){
																loadMask.remove();
																
																messagePanel.classList.remove('regex-tester-error', 'regex-tester-matched', 'regex-tester-unmatched');
																if (results.errorMessage) {
																	messagePanel.classList.add('regex-tester-error');
																	messagePanel.innerHTML = '<b><vaadin-icon icon="vaadin:close"></vaadin-icon> ' + results.errorMessage + '</b>';
																} else {
																	if (results.unitFoundRef) {
																		messagePanel.classList.add('regex-tester-matched');
																		messagePanel.innerHTML = '<b><vaadin-icon icon="vaadin:check-circle"></vaadin-icon> Matched to Unit: ' + results.unitFoundRef + '</b>';																	
																	} else {
																		messagePanel.classList.add('regex-tester-unmatched');
																		messagePanel.innerHTML = '<b><vaadin-icon icon="vaadin:close-circle"></vaadin-icon> No Unit Matched</b>';																			
																	}
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Close',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {									
															testWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});
						
						//grid
						var ruleGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true				
							},			
							children: [	
								{						
									path: 'referenceTypeDescription',
									header: 'Reference Type',					
									width: '9em'
								},
								{
									path: 'referenceNo',
									header: 'Reference No',
									width: '9em'
								},
								{
									path: 'matchOperationDescription',
									header: 'Match Operation',
									width: '9em'
								},
								{
									path: 'matchValue',
									header: 'Match Value',
									width: '9em'
								}							
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									ruleGrid.selectedItems = item ? [item] : [];										
								}
							}
						});
						
						//flex layout
						var testLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								formPanel,
								ruleGrid
							]
						});						
						
						testWin.addToContentElement(testLayout);
						
						ruleGrid.items = record.ruleViews;
						
					}
				}
			});
		};
		
	}
	
}
customElements.define('dl-unitmatch-grid', UnitMatchGrid);

